import type { ReactNode } from 'react';
import { InfoIcon } from '@phosphor-icons/react';
import { Tooltip } from '@skupreme/shared/ui';

export type ColumnHeaderProps = {
  label: ReactNode;
  hint?: ReactNode;
  /** Rendered before the label — the select-all checkbox, in practice. */
  prefix?: ReactNode;
};

export function ColumnHeader({ label, hint, prefix }: ColumnHeaderProps) {
  return (
    <span className="sk:flex sk:items-center sk:gap-2.5">
      {prefix ? (
        <span className="sk:flex sk:w-4 sk:shrink-0 sk:justify-center">
          {prefix}
        </span>
      ) : null}
      <span className="sk:flex sk:items-center sk:gap-1.5">
        <span>{label}</span>
        {hint ? (
          <Tooltip content={hint} placement="bottom start">
            <InfoIcon
              size={13}
              className="sk:shrink-0 sk:text-fg-tertiary sk:hover:text-fg-secondary"
            />
          </Tooltip>
        ) : null}
      </span>
    </span>
  );
}
